var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"positioning"},[(_vm.styleModel)?_c('div',{style:(_vm.styleModel.clock)},[(Object.entries(_vm.clock).length > 0)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.clock)}}):_vm._e()]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }